export default function toggleAllUsers({ commit }) {
   commit("TOGGLE_ALL_USERS")
}